import React from 'react';
import "./NavBar.css"
import Logo from '../logo.png'
import API from '../API';
import { Link } from 'react-router-dom';

export default class NavBar extends React.Component {


    constructor() {
        super();

        this.state = {lastY: 0, menuOpened: false}
        
    }

    componentDidMount() {
        var self = this;
        this.v = window.addEventListener('scroll', (v) => {
            var val = window.scrollY;
            if((val != 0 && self.state.lastY <= 0) || (val <= 0 && !self.state.lastY >= 0)) {
                self.state.lastY = val;
                self.forceUpdate();
            }

            
        })
    }

 

    componentWillUnmount() {
        window.removeEventListener('scroll',this.v);
    }
    render() {
        //(this.state.lastY <= 0)?'headerDiv':
        return <div className={'headerDiv scroll'} style={{paddingTop:0, position:"fixed", left:0 ,right:0, margin:"auto",display:"flex",height:70, justifyContent:"center",zIndex:1000}}>
            <div style={{display:"flex", justifyContent:"space-between", width:"86%"}}>
            <div style={{display:"flex", alignItems:"center"}}>
                <a href='../'><img  src={Logo} style={{height:30, marginTop:0, cursor:"pointer",marginRight:30}} /></a>
                {window.innerWidth > 740 && <>
                <NavBarButton href='../' high={this.state.lastY > 0} title={'Anasayfa'} />
                {/* <NavBarButton high={this.state.lastY > 0} title={'Kurumsal'} /> */}
                {API.user == undefined && <NavBarButton href='../driver' high={this.state.lastY > 0} title={'Sürücü Ol'} />}
                <NavBarButton href='../contact' high={this.state.lastY > 0} title={'Iletişim'} />
                {/* <NavBarButton high={this.state.lastY > 0} title={'More'} /> */}
                </>}
            </div>

            {window.innerWidth > 740 && <div style={{display:"flex", alignItems:"center"}}>
            <NavBarButton href="../hesapla" high={this.state.lastY > 0} title={'Fiyat Hesapla'} />
                <NavBarButton href="../sss" high={this.state.lastY > 0} title={'S.S.S'} />
                {API.user == undefined && <NavBarButton href="#" onClick={() => {
                    window.scrollTo(0,0);
                    window.scrollTo({top:10000, behavior:"smooth"})
                }} high={this.state.lastY > 0} title={'Uygulamayı Indir'} />}
                
                {API.user != undefined && 
                <div className='profilePhoto'><p>{API.user.name?API.user.name[0].toUpperCase():""}</p>
                
                    <div className='profileDropdown'>
                        <p className='profileName'>{API.user.name}</p>
                        <Link style={{textDecoration:"none"}} to='../siparislerim'><p>Siparişlerim</p></Link>
                        <p onClick={() => {
                            API.fetchClient("logout").then((e) => {
                                API.setLogin(undefined, undefined);
                                localStorage.removeItem("clientToken");
                                this.forceUpdate();
                            })
                        }}>Çıkış Yap</p>
                        
                    </div>
                </div>}
                
                {/* <NavBarButton high={this.state.lastY > 0} title={'Türkçe (Türkiye)'} /> */}
            </div>}


            {window.innerWidth <= 740 && <button onClick={() => this.setState({menuOpened: true})} style={{background:"none", outline:"none", border:"none"}}><svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      className={'menuSvg scroll'}
      version="1.1"
      viewBox='0 0 310 260'
    >
      <g transform="translate(10.016 -803.031)">
        <g
        className={'menuSvg scroll'}
          fill="none"
          stroke="black"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="49.336"
        >
          <path d="M19.668 1032.694h250.646"></path>
          <path d="M19.668 932.694h250.646"></path>
          <path d="M19.668 832.694h250.646"></path>
        </g>
      </g>
    </svg></button>}
            

            </div>


            <div style={{backgroundColor:"white", pointerEvents:"all", zIndex:10001,overflow:"hidden", position:"absolute",transition:"all .6s", left:0,top:0,bottom:0, width:(!this.state.menuOpened)?0:"100vw", height:"100vh"}}>

                <img  src={Logo} style={{height:30, marginTop:30,marginLeft:30, marginBottom:20, cursor:"pointer"}} />
                <MobileNavButton href='../' title={"Anasayfa"} />
                {/* <MobileNavButton title={"Kurumsal"} /> */}
                <MobileNavButton href='../driver' title={"Sürücü Ol"} />
                <MobileNavButton href='../contact' title={"İletişim"} />
                <MobileNavButton href='../sss' title={"Sıkça Sorulan Sorular"} />
                <MobileNavButton href='../hesapla' title={"Fiyat Hesapla"} />
                
                {/* <MobileNavButton title={"More"} /> */}
                {/* <MobileNavButton title={"Download"} /> */}

                <button onClick={(e) => {
                    
                    this.setState({menuOpened: false})
                }} style={{background:"none", outline:"none", border:"none", position:"absolute", right:25,top:25}}><svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 47.095 47.095"
      version="1.1"
      viewBox="0 0 47.095 47.095"
      xmlSpace="preserve"
      width={'20'}
    >
      <path d="M45.363 36.234l-13.158-13.16 12.21-12.21a5.906 5.906 0 000-8.358 5.908 5.908 0 00-8.356 0l-12.212 12.21-12.809-12.81a5.91 5.91 0 10-8.358 8.358l12.81 12.81L1.732 36.831a5.91 5.91 0 108.356 8.359l13.759-13.758 13.16 13.16a5.908 5.908 0 008.356 0 5.907 5.907 0 000-8.358z"></path>
    </svg></button>
            </div>
            
        </div>
    }
}

const MobileNavButton = (props) => {
    return <a className='navTitle' href={props.href} style={{paddingLeft:"5%", paddingTop:10, paddingBottom:10,fontSize:20,textDecoration:"none"}}><p style={{marginLeft:"10%"}}>{props.title}</p></a>
}

const NavBarButton = (props) => {

    if(props.onClick) 
    return <a onClick={() => {
        if(props.onClick) props.onClick();
    }} className='navTitle' href={props.href} style={{fontSize:16,textDecoration:"none",letterSpacing:"1px", lineHeight:"24px",transition:"all .2s", marginLeft:7, marginRight:7,fontWeight:"600"}}>{props.title}</a>


    return <Link className='navTitle' to={props.href} style={{fontSize:16,textDecoration:"none",letterSpacing:"1px", lineHeight:"24px",transition:"all .2s", marginLeft:7, marginRight:7,fontWeight:"600"}}>{props.title}</Link>
}


